import { enUS as e } from "./highrise626.mjs";
const n = {
  name: "en-US",
  locale: e
};
export {
  n as default
};
